import React from 'react';
import PropTypes from 'prop-types';
import '../global-sass/main.scss';

const SearchInput = ({ value, onChange, onFocus, onKeyDown, onClear }) => (
	<React.Fragment>
		<input
			type="text"
			className="form-control pr-7"
			value={value}
			aria-label="Search Input"
			onChange={onChange}
			onFocus={onFocus}
			autoComplete="off"
			onKeyDown={onKeyDown}
			aria-autocomplete="list"
		/>
		{value && (
			<button
				className="clear-button mt-1"
				onClick={onClear}
				aria-label="Clear search"
				type="button"
			>
				<i className="ddc-icon ddc-icon-close text-muted" />
			</button>
		)}
	</React.Fragment>
);

SearchInput.propTypes = {
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	onFocus: PropTypes.func.isRequired,
	onKeyDown: PropTypes.func.isRequired,
	onClear: PropTypes.func.isRequired
};

export default SearchInput;
